module.exports = __webpack_public_path__ + "13baa2570d6984db11367527b39e33ef.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/4000_r_40.mp3
// module id = 417
// module chunks = 0